import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["MarketoInputSyncWrapper"], {
    modelValue: $setup.proxyModelValue,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.proxyModelValue) = $event)),
    "marketo-input-name": $props.formInputMeta.marketoName
  }, {
    default: _withCtx(() => [
      (($setup.isFieldEnabled('State') && $setup.isFieldEnabled('Country')) && ($setup.userInputValues.Country === 'United States' || (($setup.userInputValues.Country == ''  || $setup.userInputValues.Country == null) && $setup.siteCountryCode === 'us')))
        ? (_openBlock(), _createBlock($setup["EclipseInput"], {
            key: 0,
            modelValue: $setup.proxyModelValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.proxyModelValue) = $event)),
            "without-sync-wrapper": true,
            "dropdown-option-keys": $props.dropdownOptionKeys,
            "dropdown-translations-namespace": $props.dropdownTranslationsNamespace,
            "form-input-meta": $props.formInputMeta,
            "input-state": $props.inputState
          }, null, 8 /* PROPS */, ["modelValue", "dropdown-option-keys", "dropdown-translations-namespace", "form-input-meta", "input-state"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "marketo-input-name"]))
}